import { Pipe, PipeTransform } from '@angular/core';

/**
 * Determines the platform based on the passed parameter.
 *
 */

@Pipe({
  name: 'platformMap',
  pure: true
})
export class PlatformMapPipe implements PipeTransform {
  constructor() {}
  transform(platform: string, screensize: string): string {
    if (!platform) return '';

    if (platform == 'all') {
      if (screensize == 'small') {
        return 'All Small Screen Devices';
      }
      return 'All Large Screen Devices';
    }

    switch (platform.toLowerCase()) {
      case 'roku':
        return 'Roku';
      case 'firetv':
        return 'Fire TV';
      case 'fireos':
        return 'Fire TV';
      case 'android':
        return 'Android';
      case 'ios':
        return 'iOS';
      case 'tvos':
        return 'tvOS';
      case 'samsung':
        return 'Samsung';
      case 'lgtv':
        return 'LG TV';
      default:
        return platform;
    }
  }
}
